import type { IconSvgObject } from './types';

const ChevronsLeftRightIcon: IconSvgObject = [
  ["path", { d: "M8.99996 17C8.99996 17 4.00001 13.3176 4 12C3.99999 10.6824 9 7 9 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 17C15 17 20 13.3176 20 12C20 10.6824 15 7 15 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChevronsLeftRightIcon;
